import * as React from 'react';
import cn from 'classnames';
import * as styles from './styles.css';
import { IconArrowRight16, IconArrowLeft16 } from '@cian/ui-kit';

import { handleLinkClick } from '../../../../utils/handleLinkClick';

export interface IPaginationWrapperProps {
  disabled?: boolean;
  prevHref?: string;
  nextHref?: string;

  onPrev?(): void;

  onNext?(): void;
}

interface INavigationProps {
  href?: string;
  label: string;
  testId: string;
  onClick?(): void;
}

const Navigation: React.FC<INavigationProps & React.PropsWithChildren> = ({
  href,
  label,
  testId,
  onClick,
  children,
}) =>
  href ? (
    <a
      className={styles['navigation']}
      href={href}
      aria-label={label}
      data-testid={testId}
      onClick={event => handleLinkClick(event, onClick)}
    >
      {children}
    </a>
  ) : (
    <div className={styles['navigation']} onClick={onClick} data-testid={testId}>
      {children}
    </div>
  );

export const PaginationWrapper: React.FC<IPaginationWrapperProps & React.PropsWithChildren> = ({
  children,
  disabled,
  prevHref,
  nextHref,
  onNext,
  onPrev,
}) => (
  <div className={cn(styles['wrapper'], { [styles['disabled']]: disabled })}>
    <Navigation href={prevHref} label="Предыдущая страница" testId="pagination-prev" onClick={onPrev}>
      <IconArrowLeft16 color="primary_100" />
    </Navigation>
    <div className={styles['items']}>{children}</div>
    <Navigation href={nextHref} label="Следующая страница" testId="pagination-next" onClick={onNext}>
      <IconArrowRight16 color="primary_100" />
    </Navigation>
  </div>
);

PaginationWrapper.displayName = 'PaginationWrapper';
